const Title = ({ text }) => {
  const base =
    'text-subheadingMobile md:text-subheadingDesktop text-umber uppercase font-ttDrugsTrial'

  return <span className={base}>{text}</span>
}

export default Title
